module.exports = __webpack_public_path__ + "img/menu-scan.5fd66ebc.svg";